import React from "react";
import { B2BLayout } from "../../components/b2b/B2BLayout";
import { useB2BSettings } from "../../lib/b2b";

export default function B2BPrivacy() {
  const s = useB2BSettings();
  const c = s?.contacts || {};
  const incomplete = !c.company_name || !c.email || !c.vat;
  return (
    <B2BLayout>
      <section className="mx-auto max-w-3xl px-5 py-12">
        <h1 className="font-display text-3xl font-extrabold tracking-tight text-[#0B1F3A] sm:text-4xl">Informativa privacy</h1>
        {incomplete && (
          <div data-testid="privacy-incomplete" className="mt-4 rounded-2xl border border-[#F97316]/30 bg-[#F97316]/5 p-4 text-sm text-[#0B1F3A]/80">
            Questa pagina è in fase di completamento. Prima della pubblicazione definitiva verranno inseriti i dati reali del titolare del trattamento (ragione sociale, sede, P.IVA e contatti) e i testi legali approvati.
          </div>
        )}
        <div className="mt-6 space-y-4 text-sm leading-relaxed text-[#0B1F3A]/75">
          <p>I dati che ci fornisci tramite il modulo di richiesta proposta vengono utilizzati esclusivamente per valutare i tuoi immobili, prepararti una proposta e ricontattarti nella fascia indicata.</p>
          <p><b>Titolare del trattamento:</b> {c.company_name || "da definire"}{c.vat ? ` — P.IVA ${c.vat}` : ""}.</p>
          <p><b>Contatti:</b> {c.email || "da definire"}{c.phone ? ` · ${c.phone}` : ""}.</p>
          <p><b>Finalità:</b> gestione della richiesta di proposta e dell'eventuale rapporto commerciale. Il consenso alle comunicazioni commerciali è facoltativo e separato.</p>
          <p><b>Conservazione:</b> i dati sono conservati per il tempo necessario alla gestione della richiesta e nel rispetto degli obblighi di legge.</p>
          <p><b>Diritti:</b> puoi richiedere accesso, rettifica o cancellazione dei tuoi dati scrivendo ai contatti sopra indicati.</p>
          <p className="text-xs text-[#0B1F3A]/50">Testo provvisorio, non ancora validato legalmente.</p>
        </div>
      </section>
    </B2BLayout>
  );
}
